import { render, staticRenderFns } from "./StationInheritanceTax.vue?vue&type=template&id=ac0709b6&scoped=true&"
var script = {}
import style0 from "./StationInheritanceTax.vue?vue&type=style&index=0&id=ac0709b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac0709b6",
  null
  
)

export default component.exports